import { useEffect, useState } from "react";

const DISMISS_KEY = "pwa-install-dismissed";

const isIosDevice = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
};

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const PwaInstallPrompt = () => {
  const [installEvent, setInstallEvent] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY) === "1";
    const standalone = isStandalone();
    const ios = isIosDevice();

    setShowIosHint(ios && !standalone && !dismissed);

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      if (!dismissed && !standalone) {
        setShowPrompt(true);
      }
    };

    const handleInstalled = () => {
      setInstallEvent(null);
      setShowPrompt(false);
      setShowIosHint(false);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleInstalled);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", handleInstalled);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShowPrompt(false);
    setShowIosHint(false);
  };

  const handleInstall = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    await installEvent.userChoice;
    setInstallEvent(null);
    setShowPrompt(false);
  };

  if (!showPrompt && !showIosHint) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-50 mx-auto max-w-3xl px-4">
      <div className="rounded-2xl border border-gray-200 bg-white/95 p-4 shadow-lg backdrop-blur">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-1">
            <p className="text-sm font-semibold text-gray-900">
              Install Help App
            </p>
            {showPrompt ? (
              <p className="text-xs text-gray-600">
                Get faster access, offline support, and a full-screen experience.
              </p>
            ) : (
              <p className="text-xs text-gray-600">
                On iPhone/iPad, tap Share and then “Add to Home Screen”.
              </p>
            )}
          </div>
          <div className="flex items-center gap-2">
            {showPrompt && (
              <button
                type="button"
                onClick={handleInstall}
                className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
              >
                Install
              </button>
            )}
            <button
              type="button"
              onClick={dismiss}
              className="rounded-lg border border-gray-300 px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50"
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PwaInstallPrompt;
